/**
 * AI模型偏好记忆工具
 * 用于记住用户最后选择的AI模型
 */

const MODEL_PREFERENCE_KEY = 'preferred_ai_model';

export type AIModel = 'gemini' | 'deepseek';

/**
 * 获取用户偏好的AI模型
 * @returns 用户偏好的模型，如果没有记录则返回默认值 'deepseek'
 */
export function getPreferredModel(): AIModel {
  try {
    const stored = localStorage.getItem(MODEL_PREFERENCE_KEY);
    if (stored && (stored === 'gemini' || stored === 'deepseek')) {
      return stored as AIModel;
    }
  } catch (error) {
    console.warn('Failed to read model preference from localStorage:', error);
  }
  
  // 默认返回 deepseek
  return 'deepseek';
}

/**
 * 保存用户偏好的AI模型
 * @param model 要保存的模型偏好
 */
export function setPreferredModel(model: AIModel): void {
  try {
    localStorage.setItem(MODEL_PREFERENCE_KEY, model);
  } catch (error) {
    console.warn('Failed to save model preference to localStorage:', error);
  }
}

/**
 * 清除用户的模型偏好
 */
export function clearPreferredModel(): void {
  try {
    localStorage.removeItem(MODEL_PREFERENCE_KEY);
  } catch (error) {
    console.warn('Failed to clear model preference from localStorage:', error);
  }
}

/**
 * 获取模型的显示名称
 * @param model AI模型类型
 * @returns 模型的显示名称
 */
export function getModelDisplayName(model: AIModel): string {
  return model === 'gemini' ? '模型 A' : '模型 B';
}

/**
 * 获取模型的简短名称
 * @param model AI模型类型
 * @returns 模型的简短名称
 */
export function getModelShortName(model: AIModel): string {
  return model === 'gemini' ? 'A' : 'B';
}